// extracted by mini-css-extract-plugin
export var label = "_3v-1";
export var reminder = "_3v-0";